import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-privacy-organisation',
  templateUrl: './privacy-organisation.component.html',
  styleUrls: ['./privacy-organisation.component.scss']
})
export class PrivacyOrganisationComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
